import { render, staticRenderFns } from "./ChannelSearchAddUser.vue?vue&type=template&id=5ef952a3&scoped=true&"
import script from "./ChannelSearchAddUser.vue?vue&type=script&lang=js&"
export * from "./ChannelSearchAddUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef952a3",
  null
  
)

export default component.exports